import { loader } from 'graphql.macro'

export default async function sendClientTermsAndCondition ({ dataLoaders, variables }) {
  const schema = loader('./sendClientTermsAndCondition.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      clientId: variables.clientId
    }
  })
  return response.sendClientTermsAndCondition
}
